import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import StagePicker from "composer/views/StagePicker.jsx";

import {
  Grid,
  Card,
  CardHeader,
  CardMedia,
  Button,
  TextField,
} from '@material-ui/core'

import {
  grey,
} from '@material-ui/core/colors'

const playbackKind = 3; // Portal

class PortalForm extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    var defaultPayloadData = {
      portal_arr: [
        {"stage_id": 0, "tn_id": -1},
        {"stage_id": 0, "tn_id": -1},
        {"stage_id": 0, "tn_id": -1},
        {"stage_id": 0, "tn_id": -1},
      ]
    };

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      content: "",
      targetPortalIndex: -1,
      payloadData: defaultPayloadData,
    };
    autoBind(this);

    if (this.props.playbackData != null) {
      this.state.content = this.props.playbackData['content'];
      this.state.payloadData = (this.props.playbackData['payload'] != ""? JSON.parse(this.props.playbackData['payload']) : defaultPayloadData);
    }
  }

  onContentChanged(e) {
    this.setState({
      content: e.target.value,
    });
    this.state.content = e.target.value;
  }

  selectStageClicked(index) {
    this.setState({
      targetPortalIndex: index,
    });
    this.state.targetPortalIndex = index;

    this.refs.stagePicker.setState({
      open: true,
    });
  }

  onStagePicked(stageID) {
    let payloadData = this.state.payloadData;
    let stageData = this.props.root.refs.stageViewerPage.getStageDataById(stageID);
    let tn_id = (stageData['movie_list'][0] == null? -1 : stageData['movie_list'][0]['tn_file_id']);
    payloadData['portal_arr'][this.state.targetPortalIndex]['stage_id'] = stageID;
    payloadData['portal_arr'][this.state.targetPortalIndex]['tn_id'] = tn_id;
    this.setState({
      payloadData: payloadData,
    });
    this.state.payloadData = payloadData;
  }

  getStageChoice(index) {
    let stage_id = this.state.payloadData['portal_arr'][index]['stage_id'];
    let stageData = this.props.root.refs.stageViewerPage.getStageDataById(stage_id);
    let tn_path = "";
    let stage_name = "";
    if (stageData != null) {
      tn_path = (stageData['movie_list'][0] != null?
        Config.BASE_PATH() + stageData['movie_list'][0]['tn_path']
        : "");
      stage_name = stageData['stage_name'];
    }
    return (
      <Grid item xs={12} sm={6} key={index}>
        <Card style={{margin:"5px"}}>
          <CardHeader
            titleTypographyProps={{variant:"subtitle1"}}
            title={Localization.strings.DESTINATION + " " + (index + 1) + (stage_name == ""? "" : " - " + stage_name)}
          />
          <CardMedia image="/" style={{display:'flex', alignItems:'center', justifyContent:'center', backgroundColor:grey[200], height:"20vh"}}>
            <If condition={stageData == null || tn_path == ""}>
              <Then>
                <div>
                  <Button
                    onClick={()=>this.selectStageClicked(index)}
                    variant={stageData == null? "text" : "contained"}
                    color={stageData == null? "default" : "primary"}
                  >
                    {stageData == null? Localization.strings.SELECT_STAGE : stage_name}
                  </Button>
                </div>
              </Then>
              <Else>
                <img
                  style={{cursor: "pointer", maxHeight:"100%", maxWidth:"100%", display:"block", margin:"auto"}}
                  src={tn_path}
                  onClick={()=>this.selectStageClicked(index)}
                />
              </Else>
            </If>
          </CardMedia>
        </Card>
      </Grid>
    );
  }

  validateInput() {
    let result = true;
    if (this.state.content.trim() == "") {
      this.props.root.addNotification("Description cannot be blank");
      result = false;
    }
    return result;
  }

  updatePlayback(new_id) {
    let requestObj = {
      playback_id: new_id,
      kind: playbackKind,
      trigger_time: (this.props.playbackData? this.props.playbackData['trigger_time'] : this.props.root.refs.stageViewerPage.refs.stageDetailView.refs.stageMediaView.state.playbackTime),
      should_pause_video: Config.GET_PLAYBACK_CONFIG(playbackKind)['shouldPauseVideo'],
      pos_x: 0,
      pos_y: 0,
      countdown_limit: 0,
      content: this.state.content.trim(),
      payload: JSON.stringify(this.state.payloadData),
    };
    this.props.root.refs.API.request("update_playback", requestObj, this.props.parent.updatePlaybackOK, this.props.parent.updatePlaybackFailed);
  }

  render() {
    let destination = [];
    for (let i = 0; i < 4; i++) {
        destination.push(i);
    }

    return (
      <div>
        <StagePicker parent={this} root={this.props.root} ref="stagePicker"/>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={2}>
            {Localization.strings.DESCRIPTION}
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              value={this.state.content}
              onChange={this.onContentChanged}
              helperText="Tell the user something about these portals"
            />
          </Grid>
          {destination.map((row, i) => {
            return (
              this.getStageChoice(i)
            );
          })}
        </Grid>
      </div>
    )
  }
}

export default PortalForm;
